<template>
  <div
    class="component-search-input"
    :class="{'focused': focused, 'small': small}"
    :style="`--min-width: ${width}; --max-width: ${maxWidth}; --height: ${focused && !small ? '32px' : '18px'}`">
    <sInput
      :border="false"
      class="component-search-input__input h11-links"
      :placeholder="$vuetify.breakpoint.lgAndUp && !focused ? $t('Common.Search') : ''"
      transparent
      :value.sync="model_text"
      @blur="blur"
      @clickPrefix="focus"
      @focus="focus"
      @input="input"
      @keydown_enter="applySearch()">
      <div
        slot="append"
        class="flex">
        <div
          v-if="model_text"
          class="component-search-input__btn-clear"
          @click.stop="clear()">
          <sIcon
            :size="small ? 12 : 16"
            type="cross"/>
        </div>
        <div
          class="component-search-input__btn"
          @click.stop="applySearch()">
          <sIcon
            :size="small ? 12 : 16"
            type="search"/>
        </div>
      </div>
    </sInput>
  </div>
</template>
<script>
import { debounce } from 'toolkit/utils/util'

export default {
  name: 'searchInput',
  data() {
    return {
      focused: false,
      newValue: null,
      oldValue: null,
      maxWidth: this.width
    }
  },
  props: {
    search: String,
    debounce: Boolean,
    disabled: Boolean,
    /**
     * Размер в свернутом виде
     */
    width: {
      type: String,
      default: '75px'
    },
    small: {
      type: Boolean
    }
  },
  computed: {
    model_text: {
      get() {
        return this.search
      },
      set(value) {
        this.$emit('update:search', value)
      }
    },
  },
  methods: {
    clear() {
      this.$emit('update:search', '')
      this.$nextTick(() => {
        this.debouncedFunction()
      })
    },
    applySearch(el) {
      let text
      if (!el) {
        text = this.search
      } else {
        text = el?.srcElement?.value
      }
      if (this.oldValue !== text) {
        this.oldValue = text
        this.debouncedFunction()
      }
    },
    debouncedFunction() {
      this.$emit('input', this.model_text)
      this.$emit('applySearch', this.model_text)
    },
    debounceSearch: debounce(async function () {
      this.debouncedFunction()
    }, 250),
    input() {
      if (this.debounce) {
        this.debounceSearch()
      } else {
        this.debouncedFunction()
      }
    },
    blur() {
      setTimeout(() => {
        this.focused = false
        this.maxWidth = this.width

        this.applySearch()
      }, 250)
    },
    focus() {
      this.$emit('focus')
      if (this.$el.parentElement.childElementCount === 1) {
        this.maxWidth = `${this.$el.parentElement.offsetWidth}px`
      } else {
        this.maxWidth = `${this.$el.parentElement.offsetWidth - this.$el.offsetWidth}px`
      }
      this.oldValue = this.search
      this.focused = true
    }
  },
}
</script>
<style lang="scss">
.component-search-input {
  $search-input: &;
  position: relative;
  display: flex;
  height: 21px;
  min-height: 21px;
  max-height: 21px;
  margin: auto 0;
  min-width: calc(var(--min-width) + 3px);
  transition: all 0.25s;
  &__input {
    position: absolute;
    max-width: 500px;
    width: var(--max-width);
    min-width: 30px;
    height: calc(var(--height) + 1px);
    min-height: calc(var(--height) + 1px);
    max-height: calc(var(--height) + 1px);
    right: 0px;
    z-index: 2;
    transition: all 0.25s;
    border-bottom: 1px solid gray;
  }
  &__btn-clear,
  &__btn {
    display: flex;
    border-radius: 25px;
    height: calc(var(--height) + 3px);
    width: calc(var(--height) + 3px);
    margin: 0;
    transition: all 0.25s;
    svg {
      margin: auto;
    }
  }

  &__btn-clear {
    cursor: pointer;
    &:hover,
    &:focus {
      opacity: 0.5;
      background: rgba(50, 50, 50, 0.1);
    }
  }
  & input {
    min-width: 30px;
    height: calc(var(--height) + 3px) !important;
    min-height: calc(var(--height) + 3px) !important;
    max-height: calc(var(--height) + 3px) !important;
    &::placeholder {
      text-transform: uppercase;
      font-size: 12px;
      color: var(--black-color);
    }
  }
  & .s-input__inner {
    padding: 0 0 0 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 0;
    border-width: 0;
  }
  .s-input-group__append {
    padding: 0;
  }


  &.focused {
    &:not(.small) {
      #{$search-input}__input {
        top: -8px;
      }
    }
    #{$search-input}__input {
      background: var(--white-color);
      border-radius: 31px;
      border-bottom-color: transparent;
      & .s-input__inner {
        padding: 0 0 0 12px;
        //border-radius: 0;
      }
    }
  }
}
</style>
